import React, { useState } from 'react';
import { COUNTRIES } from '../../config/countries';
import type { CountryCode } from '../../config/countries';

interface LocationSearchBarProps {
  onSearch: (lat: number, lng: number) => void;
  /** Limits the search to one country. */
  country?: CountryCode;
  placeholder?: string;
}

const LocationSearchBar: React.FC<LocationSearchBarProps> = ({ onSearch, country, placeholder }) => {
  const [query, setQuery] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSearch = async () => {
    const q = query.trim();
    if (!q) return;
    setError(null);
    try {
      const scope = country ? `&countrycodes=${COUNTRIES[country].alias.toLowerCase()}` : '';
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(q)}&format=json&limit=1${scope}`
      );
      const data = await response.json();
      if (data && data.length > 0) {
        const { lat, lon } = data[0];
        onSearch(parseFloat(lat), parseFloat(lon));
      } else {
        setError('No matching place found.');
      }
    } catch (err) {
      setError('Failed to fetch location.');
    }
  };

  return (
    <div className="absolute top-4 left-1/2 -translate-x-1/2 z-[1000] w-1/2 max-w-lg">
      <form
        className="flex space-x-2"
        onSubmit={(e) => {
          e.preventDefault();
          void handleSearch();
        }}
      >
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={placeholder ?? 'Search for a location...'}
          aria-label="Search for a place"
          className="flex-grow input input-bordered bg-surface shadow-md"
        />
        <button type="submit" className="btn btn-primary shadow-md">
          Search
        </button>
      </form>
      {error && <p className="text-error text-sm mt-1 bg-surface px-2 py-1 rounded shadow-md">{error}</p>}
    </div>
  );
};

export default LocationSearchBar;
